export default __webpack_public_path__ + "static/media/banner.b2528614.png";